import {Button} from "@material-tailwind/react";
import React, {useState} from "react";
import SelectInput from "../../system/select";
import {getPersonsNameAndFamily} from "../../../services/profile/profile";
import {getAgentsList} from "../../../services/agent/agent";
import {getFields} from "../../../services/field/field";
import {getFieldBranchesByFieldId} from "../../../services/branch/branch";
import FromToNumberField from "../../system/fromToNumberField";
import FromToDateField from "../../system/fromToDateField";

export const SERVICE_FILTER_DEFAULTS = {
  personId: null,
  agentId: null,
  fieldId: null,
  branchId: null,
  minPrice: null,
  maxPrice: null,
  minAgentShare: null,
  maxAgentShare: null,
  dateFrom: "",
  dateTo: "",
};

const SERVICE_FILTER_PARAM_MAP = {
  personId: "person_id",
  agentId: "agent_id",
  fieldId: "field_id",
  branchId: "branch_id",
  minPrice: "min_price",
  maxPrice: "max_price",
  minAgentShare: "min_agent_share",
  maxAgentShare: "max_agent_share",
  dateFrom: "date_from",
  dateTo: "date_to",
};

export function appendServiceFilterParams(params, filters) {
  Object.entries(SERVICE_FILTER_PARAM_MAP).forEach(([filterKey, paramKey]) => {
    const value = filters[filterKey];
    if (value !== null && value !== undefined && value !== "") {
      params.append(paramKey, value);
    }
  });
}

export function ServiceFilterContainer({onFiltersChange}) {
  const [filters, setFilters] = useState(SERVICE_FILTER_DEFAULTS);
  const [resetKey, setResetKey] = useState(0);

  function updateFilters(changes) {
    const nextFilters = {...filters, ...changes};
    setFilters(nextFilters);
    onFiltersChange(nextFilters);
  }

  function updateFilter(filterKey) {
    return value => {
      const changes = {[filterKey]: value};
      if (filterKey === "fieldId") {
        changes.branchId = null;
      }
      updateFilters(changes);
    };
  }

  function clearFilters() {
    const nextFilters = {...SERVICE_FILTER_DEFAULTS};
    setResetKey(prevResetKey => prevResetKey + 1);
    setFilters(nextFilters);
    onFiltersChange(nextFilters);
  }

  return (
    <>
      <div className="grid grid-cols-1 gap-4 mb-8 md:grid-cols-3 xxl:grid-cols-3">
        <div className="flex flex-col">
          <SelectInput
            key={`person-${resetKey}`}
            label={"کاربر"}
            defaultValue={filters.personId}
            refreshSignal={filters.personId}
            autoLoadService={getPersonsNameAndFamily}
            autoLoadRender={({name, family, phone}) => {
              const fullName = `${name?.trim()} ${family?.trim()}`.trim();
              return fullName + " - " + phone
            }}
            onChange={updateFilter("personId")}
          />
        </div>

        <div className="flex flex-col">
          <SelectInput
            key={`agent-${resetKey}`}
            label={"مباشر"}
            defaultValue={filters.agentId}
            refreshSignal={filters.agentId}
            autoLoadService={getAgentsList}
            autoLoadRender={({name, family}) => {
              return `${name?.trim()} ${family?.trim()}`.trim();
            }}
            onChange={updateFilter("agentId")}
          />
        </div>

        <div className="flex flex-col">
          <SelectInput
            key={`field-${resetKey}`}
            label={"رشته"}
            defaultValue={filters.fieldId}
            autoLoadService={getFields}
            onChange={updateFilter("fieldId")}
          />
        </div>

        <div className="flex flex-col">
          <SelectInput
            key={`branch-${filters.fieldId || "all"}-${resetKey}`}
            label={"گرایش"}
            defaultValue={filters.branchId}
            refreshSignal={filters.fieldId}
            autoLoadService={getFieldBranchesByFieldId}
            autoLoadServiceData={filters.fieldId}
            autoLoadRender={({title}) => {
              return title;
            }}
            onChange={updateFilter("branchId")}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-1 mb-2 md:grid-cols-2 xxl:grid-cols-2">
        <FromToNumberField
          key={`price-${resetKey}`}
          label="مبلغ"
          fromNumber={filters.minPrice}
          setFromNumber={updateFilter("minPrice")}
          toNumber={filters.maxPrice}
          setToNumber={updateFilter("maxPrice")}
        />

        <FromToNumberField
          key={`agent-share-${resetKey}`}
          label="سهم مباشر"
          fromNumber={filters.minAgentShare}
          setFromNumber={updateFilter("minAgentShare")}
          toNumber={filters.maxAgentShare}
          setToNumber={updateFilter("maxAgentShare")}
        />

        <FromToDateField
          key={`date-${resetKey}`}
          label="تاریخ"
          fromDate={filters.dateFrom}
          setFromDate={updateFilter("dateFrom")}
          toDate={filters.dateTo}
          setToDate={updateFilter("dateTo")}
        />
      </div>

      <div className="flex flex-row">
        <Button variant="gradient" color="gray" onClick={clearFilters} className="ml-1">
          <span>حذف فیلتر</span>
        </Button>
      </div>
    </>
  );
}
